/**
 * @fileoverview gRPC-Web generated client stub for contact_sales
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.1
// 	protoc              v3.20.3
// source: api/dashboard/v2/contact_sales_service.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var api_dashboard_v2_contact_sales_message_pb = require('../../../api/dashboard/v2/contact_sales_message_pb.js')
const proto = {};
proto.contact_sales = require('./contact_sales_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.contact_sales.ContactSalesClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.contact_sales.ContactSalesPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contact_sales.ContactSalesRequest,
 *   !proto.contact_sales.ContactSalesResponse>}
 */
const methodDescriptor_ContactSales_ContactSales = new grpc.web.MethodDescriptor(
  '/contact_sales.ContactSales/ContactSales',
  grpc.web.MethodType.UNARY,
  api_dashboard_v2_contact_sales_message_pb.ContactSalesRequest,
  api_dashboard_v2_contact_sales_message_pb.ContactSalesResponse,
  /**
   * @param {!proto.contact_sales.ContactSalesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  api_dashboard_v2_contact_sales_message_pb.ContactSalesResponse.deserializeBinary
);


/**
 * @param {!proto.contact_sales.ContactSalesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contact_sales.ContactSalesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contact_sales.ContactSalesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.contact_sales.ContactSalesClient.prototype.contactSales =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/contact_sales.ContactSales/ContactSales',
      request,
      metadata || {},
      methodDescriptor_ContactSales_ContactSales,
      callback);
};


/**
 * @param {!proto.contact_sales.ContactSalesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contact_sales.ContactSalesResponse>}
 *     Promise that resolves to the response
 */
proto.contact_sales.ContactSalesPromiseClient.prototype.contactSales =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/contact_sales.ContactSales/ContactSales',
      request,
      metadata || {},
      methodDescriptor_ContactSales_ContactSales);
};


module.exports = proto.contact_sales;

